import React from "react";
import Select from "react-select";
import { Form, Col } from "react-bootstrap";
import { useFormikContext, useField } from "formik";
import makeAnimated from "react-select/animated";
import useMultiSelect from "../../../custom-hooks/useMultiSelect";

const BMultiSelectField = ({
    as,
    md,
    controlId,
    value,
    label,
    isMulti,
    closeMenuOnSelect,
    isClearable,
    error,
    serverError,
    options,
    ...props
}) => {
    const [field, meta] = useField(props);
    const { setFieldValue, setFieldTouched } = useFormikContext();
    /**
     * This is a custom hook from useMultiSelect,
     *
     */
    const { selectClass, customStyle, customTheme } = useMultiSelect({
        error,
        serverError
    });

    /**
     * Will manually set the value belong to the name props in the Formik form using setField
     */

    function handleOptionChange(selection) {
        setFieldValue(props.name, selection);
    }

    /**
     * Manually updated the touched property for the field in Formik
     */
    function updateBlur() {
        setFieldTouched(props.name, true);
    }

    return (
        <Form.Group controlId={controlId}>
            {label && <Form.Label>{label}</Form.Label>}
            <Select
                {...field}
                {...props}
                onBlur={updateBlur}
                onChange={handleOptionChange}
                isMulti={isMulti}
                options={options}
                closeMenuOnSelect={closeMenuOnSelect}
                isSearchable
                isClearable={isClearable}
                components={makeAnimated()}
                styles={customStyle}
                className={selectClass}
                classNamePrefix="react-select"
                theme={customTheme}
                placeholder={meta.touched && meta.error ? "" : null}
                // placeholder={meta.touched&&meta.error?"Please choose atleast one option":null}
                // noOptionsMessage={()=>"No option available"}
                // components={{ customInput }}
            />
            {meta.touched && meta.error ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
            {!!error ? <small className="text-danger">{error}</small> : null}
        </Form.Group>
    );
};

BMultiSelectField.defaultProps = {
    as: Col,
    md: 6,
    isMulti: true,
    closeMenuOnSelect: false,
    isClearable: true,
    error: "",
    serverError: null
};

export default BMultiSelectField;
